import React, { useState, useEffect } from "react";
import NavBar from "../components/common/NavBar";
import Footer from "../components/common/Footer";
import TopImage from "../components/common/TopImage";

const SyllabusPage = (props) => {
  const [selectedClass, setSelectedClass] = useState("Grade");

  const handleClassChange = (event) => {
    setSelectedClass(event.target.value);
  };

  const generatePdfUrl = (selectedClass) => {
    const basePath = process.env.PUBLIC_URL || '';
    const pdfFileName = `${selectedClass}.pdf`;
    return `${basePath}/assets/Syllabus/${pdfFileName}`;
  };

  const downloadSyllabus = () => {
    const pdfUrl = generatePdfUrl(selectedClass);

    const anchor = document.createElement("a");
    anchor.href = pdfUrl;
    anchor.download = `syllabus-${selectedClass}.pdf`;
    anchor.click();
  };

  useEffect(() => {
    setSelectedClass("Grade");
  }, []);

  return (
    <div>
      <NavBar />
      <TopImage text="Syllabus"/>

      <div className="flex flex-col px-5 capitalize">
        
        <div className="flex flex-col self-center mt-20 w-full whitespace-nowrap max-w-[984px] max-md:mt-10 max-md:max-w-full">
          <div className="flex gap-5 justify-between mt-20 pr-20 max-md:flex-wrap max-md:pr-5 max-md:max-w-full">
            <div className="flex-auto my-auto text-2xl font-bold tracking-wide text-black">
              Grade/Year:
            </div>
            <div className="grow justify-center items-start  text-center  p-2 text-base bg-zinc-200 rounded-md placeholder w-40 ">
              <select
                value={selectedClass}
                onChange={handleClassChange}
                className="select-input  text-center justify-center p-2 text-base bg-zinc-200 rounded-md "
              >
                <option value="Grade">Select Grade</option>
                {Array.from({ length: 10 }, (_, i) => i + 1).map((grade) => (
                  <option key={grade} value={grade}>
                    {grade}
                  </option>
                ))}
              </select>
            </div>
          </div>
          <div className="flex justify-center self-center mt-20 max-md:flex-wrap">
            {selectedClass !== "Grade" && (
              <div className="justify-center self-center mb-20 max-md:my-8 px-8 py-4 text-base tracking-wider text-center bg-sky-700 rounded-2xl shadow-sm text-zinc-100 max-md:px-5 max-md:mt-10">
                <button onClick={downloadSyllabus} className="cursor-pointer">
                  Download Syllabus
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default SyllabusPage;
